import { Injectable } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private cp: CurrencyPipe) { }

  public getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  //#region Date Helper
  public formatDate(inputDate: Date) {
    const dateTimeformat = new Intl.DateTimeFormat('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
    return dateTimeformat.format(inputDate);
  }
  //#endregion
  //#region Email Helper
  public isValidEmail(email) {
    const regExp = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;    //need to varify regex for email
    return regExp.test(String(email).toLowerCase());
  }
  //#endregion

  //#region Determine Root Asset Path
  public getRootAssetPath() {

  }
  //#endregion
  convertIntToString(num) {
    let result: string = '';
    switch (num) {
      case 1: result = '1st'; break;
      case 2: result = '2nd'; break;
      case 3: result = '3rd'; break;
      case 4: result = '4th'; break;
      case 5: result = '5th'; break;
      default: break;
    }
    return result;
  }

  deepCopy(source, destination) {
    destination = JSON.parse(JSON.stringify(source));
    return destination;
  }

  public formatCurrencyTwodigit(value: any) {
    return this.cp.transform(value, 'USD', 'symbol', '1.2-2');
  }
}

